module.exports = __webpack_public_path__ + "img/bg-img-five.9707cba6.png";